export const getCurrentDateTime = () => {
  const now = new Date();

  // Format date (YYYY-MM-DD) in Europe/London timezone
  const londonDate = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/London",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(now);

  // Format time (HH:mm) in Europe/London timezone
  const londonTime = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/London",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).format(now);

  return {
    currentDate: londonDate, // YYYY-MM-DD
    currentTime: londonTime, // HH:mm (24-hour format)
  };
};

export const addMinutes = (time, minutesToAdd) => {
  const [hours, minutes] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes + minutesToAdd);

  const updatedHours = String(date.getHours()).padStart(2, "0");
  const updatedMinutes = String(date.getMinutes()).padStart(2, "0");

  return `${updatedHours}:${updatedMinutes}`;
};

export const getCurrentWeekDetails = () => {
  const today = new Date();

  // Get the current day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
  const dayOfWeek = today.getDay();

  // Calculate Monday of the current week
  const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
  const startDate = new Date(today);
  startDate.setDate(today.getDate() + diffToMonday);

  // Calculate Sunday of the current week
  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + 6);

  // Get the ISO week number
  // const firstThursday = new Date(today.getFullYear(), 0, 4); // Jan 4 ensures first week is correct
  const startOfYear = new Date(today.getFullYear(), 0, 1);
  const pastDays = Math.floor((today - startOfYear) / (24 * 60 * 60 * 1000));
  const weekNumber = Math.ceil((pastDays + startOfYear.getDay() + 1) / 7);

  // Format the week like "YYYY-W##"
  const formattedWeek = `${today.getFullYear()}-W${String(weekNumber).padStart(2, "0")}`;

  return {
    startDate: startDate.toISOString().split("T")[0], // YYYY-MM-DD format
    endDate: endDate.toISOString().split("T")[0], // YYYY-MM-DD format
    currentWeekDetails: formattedWeek, // "YYYY-W##" format
  };
};

export const getYearWeek = (dateString) => {
  let date = new Date(dateString);
  let firstJan = new Date(date.getFullYear(), 0, 1);
  let weekNumber = Math.ceil((((date - firstJan) / 86400000) + firstJan.getDay() + 1) / 7);
  return `${date.getFullYear()}-W${weekNumber.toString().padStart(2, "0")}`;
};
